import type { PermissionFlagsWire } from '@/userManagement/domain/types/PermissionFlagsWire';

/** Feature row inside GET .../users/{crossUserId}/permissions category payload (runtime / legacy BE shape). */
export interface UserPermissionsDetailFeatureWire {
  featureId?: number;
  featureName?: string;
  allowRead?: boolean;
  allowWrite?: boolean;
  allowDelete?: boolean;
  allowCentralAccess?: boolean;
  allowExcelExport?: boolean;
}

export interface UserPermissionsDetailCategoryWire {
  name?: string;
  features?: UserPermissionsDetailFeatureWire[] | null;
}

export interface UserPermissionsDetailWire {
  categories?: UserPermissionsDetailCategoryWire[] | null;
  permissionRole?: { id?: number } | null;
}

function toFeatureId(value: number | undefined): number | null {
  if (value === undefined) return null;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) && !Number.isNaN(n) ? n : null;
}

/**
 * Flattens GET /users/{crossUserId}/permissions category payload
 * into wire flag rows for {@link mapPermissionFlagsWireToPermissions}.
 */
export function flattenUserPermissionsDetailToFlagsWire(detail: UserPermissionsDetailWire | undefined): PermissionFlagsWire[] {
  const out: PermissionFlagsWire[] = [];
  for (const cat of detail?.categories ?? []) {
    for (const f of cat.features ?? []) {
      const featureId = toFeatureId(f.featureId);
      if (featureId === null) continue;
      out.push({
        featureId,
        allowRead: Boolean(f.allowRead),
        allowWrite: Boolean(f.allowWrite),
        allowDelete: Boolean(f.allowDelete),
        allowCentralAccess: Boolean(f.allowCentralAccess),
        allowExcelExport: Boolean(f.allowExcelExport)
      });
    }
  }
  return out;
}
